export default "__VITE_ASSET__BHLFXxLV__"